const PAYOUT_CURRENCY_PATTERN = /^[A-Z0-9]{2,12}$/;

/**
 * Effective currencies for manual deposit and payment-method configuration.
 * Base order is preserved. Payout currencies are appended and deduplicated.
 * A missing or empty payout list leaves the base list unchanged.
 */
export function unionPaymentConfigurationCurrencies(
  base: readonly string[] | null | undefined,
  payout: readonly string[] | null | undefined,
): string[] {
  const effective: string[] = [];
  const seen = new Set<string>();

  for (const entry of Array.isArray(base) ? base : []) {
    const code = String(entry ?? "").trim();
    const key = code.toUpperCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    effective.push(code);
  }

  for (const entry of Array.isArray(payout) ? payout : []) {
    const code = String(entry ?? "")
      .trim()
      .toUpperCase();
    if (!PAYOUT_CURRENCY_PATTERN.test(code) || seen.has(code)) continue;
    seen.add(code);
    effective.push(code);
  }

  return effective;
}
